import { Spinner } from "@/components/ui/spinner";
import { SpecialtyGroup } from "./specialty-group";
import { useSpecialties } from "../api/get-specialties";

export const SpecialtyList = () => {
    const { data: specialties, isLoading, isError } = useSpecialties();

    const groupedSpecialties = Object.values(
        specialties?.reduce((groups, specialty) => {
            const { categoryId } = specialty;

            if (!groups[categoryId]) {
                groups[categoryId] = {
                    categoryId,
                    categoryTitle: specialty.categoryTitle,
                    categoryDescription: specialty.categoryDescription,
                    specialties: [],
                };
            }

            groups[categoryId].specialties.push(specialty);

            return groups;
        }, {}) ?? {},
    );

    if (isLoading || isError) {
        return (
            <div className="grid h-50 place-items-center py-10">
                <Spinner size="lg" />
            </div>
        );
    }

    return (
        <div className="space-y-12">
            {groupedSpecialties.map((group) => (
                <SpecialtyGroup
                    key={group.categoryId}
                    group={group}
                    specialties={group.specialties}
                />
            ))}
        </div>
    );
};
